// extracted by mini-css-extract-plugin
export var actionIcon = "_uh-0";